<template>
  <fb-list-body :pager="pager" :showSearchForm="false" :showBtnGroup="false"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('/lock-screen-ads-add')">{{ $t('lang.新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>


    <template slot="table">

      <el-row :gutter="24">
        <el-col :span="4">

          <div class="menu-box">
            <span class="menu-title">{{ $t('lang.型号') }}</span>

            <el-menu :default-active="menuActive" @select="handleClickRow" @open="handleOpenMenu"
                     :default-openeds="openeds">

              <template v-for="(item, index) in productTree">

                <el-submenu :index="index + ''" class="menu-item" :key="index" v-if="item.products.length">
                  <template slot="title">
                    <span>{{ item.subBrandName }}</span>
                  </template>

                  <template v-for="(second, idx) in item.products">
                    <el-menu-item :key="index +'_second_' + idx" :index="index + '-' + idx" class="submenu-item">
                      {{ second.subModel }}
                    </el-menu-item>
                  </template>

                </el-submenu>

                <el-menu-item :index="index + ''" class="menu-item" :key="index" v-else>
                  <span slot="title">{{ item.subBrandName }}</span>
                </el-menu-item>

              </template>


            </el-menu>

          </div>



        </el-col>

        <el-col :span="20">
          <el-row style="margin-bottom: 24px">
            <el-button size="small" type=primary icon="el-icon-plus"
                       @click="$router.push({path: '/lock-screen-ads-add', query: {code: searchForm.subBrandProductCode}})">
              {{ $t('lang.新增') }}
            </el-button>
            <el-button size="small" icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
          </el-row>
          <el-row>
            <el-table :data="tableData" @selection-change="handleSelectionChange" @row-dblclick="handleEdit" border>

              <el-table-column type="selection" width="50"></el-table-column>

              <el-table-column prop="number" :label="$t('lang.序号')"></el-table-column>
              <el-table-column :label="$t('lang.图片')">
                <template slot-scope="scope">
                  <el-image
                      style="width: 100px; height: 100px"
                      :src="scope.row.photo | filterImg(that)"/>

                </template>
              </el-table-column>

              <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
                <template slot-scope="scope">
                  <el-button size="mini"
                             @click='$router.push({path: "/lock-screen-ads-edit",query: {code: scope.row.code} });'
                             plain
                             type="primary">{{$t('lang.编辑')}}
                  </el-button>
                  <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{$t('lang.删除')}}</el-button>
                </template>
              </el-table-column>


            </el-table>
          </el-row>

        </el-col>
      </el-row>


    </template>


  </fb-list-body>
</template>

<script>

export default {
  name: "LockScreenAdsList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.lockScreenAds.list,
        delete: this.$api.lockScreenAds.delete,
        batchDelete: this.$api.lockScreenAds.batchDelete,
      },
      searchForm: {
        subBrandProductCode: ''
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      that: this,
      openeds: [],
      menuActive: '0',
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
    productTree() {
      const vm = this;
      let list = this.$store.state.brandProductTree;
      list.forEach((i, index) => {
        vm.openeds.push(index);
      });
      if (list.length && list[0].products.length) {
        vm.menuActive = '0-0';
      } else {
        vm.menuActive = '0';
      }
      return list;
    }
  },
  watch: {
    menuActive: {
      handler(val) {
        this.handleClickRow(val)
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });

        if(this.searchForm.subBrandProductCode) {
          this.handleSearch();
        }
      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();

      },
      deep: true
    }

  },
  methods: {
    handleClickRow(e) {
      let index = e.split('-');
      if(index.length == 1) return;
      let item = this.productTree[index[0]];
      let subItem= item.products[index[1]];
      this.searchForm['subBrandProductCode'] = subItem.code;
      this.tableData = [];
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleSearch();
    },

    handleOpenMenu(index) {
      this.handleClickRow(index);
    },

    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

.menu-box {
  width: 100%;
  background: #eee;
}

.menu-title {
  display: inline-block;
  width: 100%;
  font-size: 14px;
  line-height: 40px;
  background: #f5f5f5;
  box-sizing: border-box;
  padding-left: 16px;
  border: 1px solid #ddd;
  border-bottom: 0px;
}

.menu-item {
  border: 1px solid #ddd;
  border-top: 0px;
}

.submenu-item {
  border-top: 1px solid #ddd;
}


.el-menu-item.is-active {
  background: #81b6ec;
  color: #ffffff;
}

/deep/ .el-submenu .el-menu-item {
  min-width: 0;
}

</style>
